<template>
  <div class="enter_innovation_wrap">
    <div class="enter_img">
      <div class="img_tit hidden-xs-only">{{ $t('esgEvaluation2.title') }}</div>
      <div class="img_tit hidden-sm-and-up">{{ $t('esgEvaluation2.title') }}</div>
    </div>
    <div class="content_wrap">
      <div class="content_inner">
        <div class="develop_wrap">
          <div class="develop_left">
            <h1>{{ $t('esgEvaluation2.desc') }}</h1>
          </div>
        </div>
        
        <!-- 添加两个图片，上下排列，与标题对齐 -->
        <div class="esg_images_wrap">
          <div class="esg_image_item">
            <img :src="esgImage1" alt="ESG Image 1" />
          </div>
          <div class="esg_image_item">
            <img :src="esgImage2" alt="ESG Image 2" />
          </div>
          <div class="esg_image_item">
            <img :src="esgImage3" alt="ESG Image 3" />
          </div>
        </div>
      </div>
    </div>
    
    <!-- 将desc2放到最下面，左对齐 -->
    <div class="desc2_wrap">
      <div class="desc2_inner">
        <p class="desc2_text">{{ $t('esgEvaluation2.desc2') }}</p>
      </div>
    </div>
    
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
export default {
  data() {
    return {
      esgImages: {
        zh: {
          image1: require('@/assets/img/hly/new2/esg-1.png'),
          image2: require('@/assets/img/hly/new2/esg-2.png'),
          image3: require('@/assets/img/hly/new2/esg-3.png')
        },
        en: {
          image1: require('@/assets/img/hly/new2/esg-1.png'),
          image2: require('@/assets/img/hly/new2/esg-2.png'),
          image3: require('@/assets/img/hly/new2/esg-3.png')
        }
      }
    }
  },
  computed: {
    esgImage1() {
      return this.esgImages[this.$i18n.locale]?.image1 || this.esgImages.zh.image1;
    },
    esgImage2() {
      return this.esgImages[this.$i18n.locale]?.image2 || this.esgImages.zh.image2;
    },
    esgImage3() {
      return this.esgImages[this.$i18n.locale]?.image3 || this.esgImages.zh.image3;
    }
  },
  methods: {
    toCBAM(){
      window.open('http://test.cbam.1clicktong.com/login', '_blank')
    }
  },
  components: {
    CallMe,
    MobileCallme,
  },
}
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;
  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url('../../assets/img/hly/new/关于我们/关于我们.jpg') 0 0 no-repeat;
    background-size: cover;
    background-position: center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }
    .learn-more {
      background: #f29c11;
      font-size: 20px;
      color: #fff;
      border: none;
      padding: 0.5rem 1.5rem;
      border-radius: 5px;
      cursor: pointer;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, 150%);
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
        margin-top: -1.5rem;
      }
    }
  }
  
  .content_wrap {
    width: 100%;
    margin-top: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
    .content_inner {
      width: 70%;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }
      
      .develop_wrap {
        width: 100%;
        margin-bottom: 30px;
        .develop_left {
          padding: 20px 0;
          h1 {
            font-size: 26px;
            @media screen and (max-width: 768px) {
              font-size: 0.95rem;  
            }
          }
        }
      }
      
      /* 图片样式，与标题对齐，去掉边框 */
      .esg_images_wrap {
        width: 100%;
        .esg_image_item {
          margin-bottom: 30px;
          @media screen and (max-width: 768px) {
            margin-bottom: 20px;
          }
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
  
  /* desc2样式，左对齐 */
  .desc2_wrap {
    width: 100%;
    margin-top: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
    .desc2_inner {
      width: 70%;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }
      .desc2_text {
        font-size: 18px;
        color: #5b6e74;
        line-height: 1.8;
        text-align: left;
        @media screen and (max-width: 768px) {
          font-size: 14px;
          line-height: 1.6;
        }
      }
    }
  }
}
</style>